module.exports = __webpack_public_path__ + "img/background-profiel.c715f032.png";